export default __webpack_public_path__ + "static/home-71eed6103939f43facfca59a41f0d27c.jpg";